import { render, staticRenderFns } from "./StaffNavigator.vue?vue&type=template&id=64476f02&scoped=true&"
import script from "./StaffNavigator.vue?vue&type=script&lang=js&"
export * from "./StaffNavigator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64476f02",
  null
  
)

export default component.exports